import React, { useEffect, useState } from 'react';
import { Table, Spin, Typography, Button } from 'antd';
import { Link } from 'react-router-dom';
import { PlusOutlined, EditOutlined } from '@ant-design/icons';
import PersistentDrawerLeft from "../../../components/reusable/admin/Main";
import { restApi } from "../../../constants/api";
import styled from 'styled-components';

const { Title } = Typography;

const Wrapper = styled.div`
  padding: 24px;
`;

const StyledCard = styled.div`
  background: white;
  border-radius: 16px;
  padding: 24px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.06);
  border: 1px solid #f0f0f0;
`;

const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
`;

const StyledTitle = styled(Title)`
  && {
    margin: 0;
    font-weight: 600;
    font-size: 26px;
  }
`;

const AddButton = styled(Button)`
  background-color: #52c41a !important;
  border-color: #52c41a !important;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(82, 196, 26, 0.4);
`;

const EditButton = styled(Button)`
  border-radius: 6px;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1);
  background-color: #5a7a76;
  border: none;
`;

const SpinnerContainer = styled.div`
  text-align: center;
  padding: 3rem;
`;

const TableWrapper = styled.div`
  overflow-x: auto;
  .ant-table-thead > tr > th {
    background-color: #77d6c9 !important;
  }

  .ant-table-thead > tr > th {
    color: black;
  }
`;

const UserTypesList = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);

  // Role Set 
  const rawRole = localStorage.getItem('role');
  const role = rawRole ? rawRole.trim().toUpperCase() : null;
  // console.log("Normalized Role:", role);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response: any = await restApi('/api/user-types', 'GET');
        setData(response?.data);
      } catch (error) {
        console.error('Error fetching Designations:', error);
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, []);

  const columns: any = [
    {
      title: 'ID',
      dataIndex: 'id',
      key: 'id',
      align: 'center',
      width: 70,
    },
    {
      title: 'Designation',
      dataIndex: 'type_name',
      key: 'type_name',
      responsive: ['xs', 'sm', 'md', 'lg'],
    },
    {
      title: 'Per Month Salary',
      dataIndex: 'perMonthSalary',
      key: 'perMonthSalary',
      align: 'center',
    },
    {
      title: 'Total Days',
      dataIndex: 'total_number_of_days',
      key: 'total_number_of_days',
      align: 'center',
    },
    {
      title: 'Reminder Days',
      dataIndex: 'no_of_days_reminders',
      key: 'no_of_days_reminders',
      align: 'center',
    },
    ...(role !== 'VIEWER'
      ? [
        {
          title: 'Actions',
          key: 'actions',
          align: 'center',
          render: (_: any, record: any) => (
            <Link to={`/admin/user_types/update/${record.id}`}>
              <EditButton type="primary" icon={<EditOutlined />} size="small">
                Edit
              </EditButton>
            </Link>
          ),
        },
      ]
      : [])
  ];

  return (
    <PersistentDrawerLeft>
      <Wrapper>
        <StyledCard>
          <Header>
            <StyledTitle level={3}>👥 Designation </StyledTitle>
            {role !== 'VIEWER' && (
              <Link to="/admin/user_types/create">
                <AddButton type="primary" icon={<PlusOutlined />} size="middle">
                  Add Designation
                </AddButton>
              </Link>
            )}
          </Header>

          {loading ? (
            <SpinnerContainer>
              <Spin size="large" />
            </SpinnerContainer>
          ) : (
            <TableWrapper>
              <Table
                columns={columns}
                dataSource={data}
                rowKey="id"
                bordered
                pagination={{ pageSize: 10 }}
                size="middle"
                style={{
                  borderRadius: 12,
                  overflow: 'hidden',
                }}
              />
            </TableWrapper>
          )}
        </StyledCard>
      </Wrapper>
    </PersistentDrawerLeft>
  );
};

export default UserTypesList;
